export const ORDER_REFERENCE_COOKIE_NAME = 'orderReference';
